export default __webpack_public_path__ + "static/media/last_page.e33782ec.svg";